import { inject as service } from '@ember/service';
import Route from 'cio/routes/base';
import DS from 'ember-data';
import IntegrationTypeController from './controller';

export default class IntegrationsTypeIndex extends Route {
  @service store!: DS.Store;

  async model() {
    let { type } = this.paramsFor('integrations.type') as Record<string, string>;
    let integrations = await this.store.findAll('integration');

    return integrations.find((integration) => integration.id === type);
  }

  resetController(controller: IntegrationTypeController, isExiting: boolean, transition: any) {
    super.resetController(controller, isExiting, transition);

    if (isExiting) {
      controller.set('showNotify', false);
    }
  }
}
